/* RESPONSIBLE TEAM: team-help-desk-experience */

enum Theme {
  Light = 'light',
  Dark = 'dark',
  System = 'system',
}

export default Theme;
